import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import moment from "moment";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import $ from "jquery";
import { fetchUsers, createUser, updateUserById, deleteUser } from '../../actions/users';
import {
  fetchCustomersNew,
  sendUserInvite
} from "../../actions/customer";
import {
  IMAGE_URL
} from "../../utils/constant";
import { countryCodes } from "../../utils/countryCode";
import { toastr } from "react-redux-toastr";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import  imgDummy  from "../../assets/images/dummyImage.png";


const InviteUser = (props) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const history = useHistory();
  let users = useSelector((state) => state?.users?.response?.data || []);
  let userss = useSelector((state) => state);
  const authUser = useSelector(
    (state) => state?.auth?.user
  );
  let customers = useSelector((state) => state?.customer?.response?.data);
  let selectedClient;
  if (id) {
    selectedClient = customers?.filter((val) => val._id == id);
    selectedClient = selectedClient?.[0] || {};
  } else {
    selectedClient = authUser?.organisationId || {};
  }
  const [search, setSearch] = useState("");
  const [userId, setUserId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [accessData, setAccessData] = useState([
    { id: 1, val: "admin", text: "Admin" },
    { id: 1, val: "client", text: "Client" },
  ]);
  const [isModal, setModal] = useState("");
  const [reminderModal, setReminderModal] = useState(false);
  const [emailId, setEmailId] = useState("");

  const [primaryContactName, setContactName] = useState("");
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [orgAdmin, setOrgAdmin] = useState(false);
  const [services, setServices] = useState([]);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [accessValue, setAccessLevel] = useState(accessData[0].val)
  const [loading, setLoading] = useState(true);

  if (history.location.pathname.indexOf("vendor") != -1 && loading) {
    setAccessData([{ id: 4, val: "tprm-question-responder", text: "Vendor" }])
    setAccessLevel("tprm-question-responder");
    setLoading(false)
  } else {
    if (authUser && loading && !id) {
      if (authUser.accessLevel == "client") {
        setAccessData([{ id: 3, val: "admin", text: "Admin" }, { id: 5, val: "client", text: "Client" }])
        setAccessLevel("client");
        setLoading(false)
      } else if (authUser.accessLevel == "mssp") {
        setAccessData([{ id: 3, val: "mssp", text: "MSSP" }])
        setAccessLevel("MSSP");
        setLoading(false)
      } else {
        setLoading(false)
      }
    }
    if (id && loading && selectedClient) {
      if (selectedClient.clientType == 1) {
        setAccessData([{ id: 3, val: "admin", text: "Admin" }, { id: 5, val: "client", text: "Client" }])
        setAccessLevel("client");
        setLoading(false);
      } else if (selectedClient.clientType == 3) {
        setAccessData([{ id: 3, val: "mssp", text: "MSSP" }])
        setAccessLevel("mssp");
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    fetchCustomersNew(dispatch);
    fetchUsers(props.match.params.id || authUser?.organisationId?._id, dispatch);
  }, []);

  const downloadCsvData = Array.isArray(users)
    ? users.map((res) => ({
      fullName: res?.fullName,
      EmailAddress: res?.email,
      ContactNumber: res?.contact || "NA",
      Role: res?.accessLevel,
      PasswordReset: res?.passwordReset ? "Yes" : "No",
      RegistrartionDate: moment(res?.website).format(
        "DD/MM/YYYY hh:mm a"
      )
    }))
    : [];

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(data, fileName + ".xlsx");
  };

  let mapData = search == ""
    ? users
    : users?.filter((row) => ((row?.fullName?.toLowerCase()?.indexOf(search?.toLowerCase()) != -1) || row?.email?.toLowerCase()?.indexOf(search?.toLowerCase()) != -1))

  const submitForm = () => {
    if (primaryContactName == "") {
      toastr.error("Error", "Please enter name.");
      return false;
    }
    if (email == "") {
      toastr.error("Error", "Please enter email.");
      return false;
    }
    var EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!EmailRegex.test(email)) {
      toastr.error("Error", "Please enter valid email id.");
      return false;
    }

    let _services = [];
    if (accessValue == "Client") {
      _services = selectedClient?.services || [];
    }

    let transformedPermissions = {
      modulePermissions: {
        de: {
          e: permissions.dataExposure.edit,
          r: permissions.dataExposure.view
        },
        asm: {
          e: permissions.attackSurface.edit,
          r: permissions.attackSurface.view
        },
        bs: {
          e: permissions.brandSecurity.edit,
          r: permissions.brandSecurity.view
        },
        tprm_risk_assessment: {
          e: permissions.tprm_risk_assessment.edit, 
          r: permissions.tprm_risk_assessment.view
        },
        tprm_questionaire: {
          e: permissions.tprm_questionaire.edit,
          r: permissions.tprm_questionaire.view
        }
      }
    };


    if (isEdit) {
      updateUserById(
        {
          id: userId,
          fullName: primaryContactName,
          email: email,
          contact: phone,
          twoFactorEnabled: twoFactorEnabled,
          orgAdmin: accessValue == "Client" ? true : false,
          services: accessValue == "Client" ? _services : services,
          accessLevel: accessValue,
          countryCode: countryCode,
          modulePermissions: transformedPermissions?.modulePermissions,
          organisationId: id || authUser?.organisationId?._id
        },
        dispatch,
        props.match.params.id || authUser?.organisationId?._id,
      );
    } else {
      createUser(
        {
          fullName: primaryContactName,
          contact: phone,
          accessLevel: accessValue,
          twoFactorEnabled: twoFactorEnabled,
          orgAdmin: accessValue == "Client" ? true : false,
          services: accessValue == "Client" ? _services : services,
          email: email,
          countryCode: countryCode,
          modulePermissions: transformedPermissions?.modulePermissions,
          organisationId: id || authUser?.organisationId?._id
        },
        dispatch,
        history,
        props.match.params.id || authUser?.organisationId?._id,
      );
    }

    setModal("")
  }

  const addModal = () => {
    setIsEdit(false);
    setContactName("")
    setEmail("")
    setPhone("")
    setCountryCode("")
    setAccessLevel(accessData[0].val)
    setModal("Form Wizard modal")
  }

  const editModal = (row) => {
    setPermissions({
      attackSurface: {
        main: (row?.modulePermissions?.asm?.e && row?.modulePermissions?.asm?.r) || false,
        edit: row?.modulePermissions?.asm?.e || false,
        view: row?.modulePermissions?.asm?.r || false
      },
      dataExposure: {
        main: (row?.modulePermissions?.de?.e && row?.modulePermissions?.de?.r) || false,
        edit: row?.modulePermissions?.de?.e || false,
        view: row?.modulePermissions?.de?.r || false
      },
      brandSecurity: {
        main: (row?.modulePermissions?.bs?.e && row?.modulePermissions?.bs?.r) || false,
        edit: row?.modulePermissions?.bs?.e || false,
        view: row?.modulePermissions?.bs?.r || false
      },
      tprm_risk_assessment: {
        main: (row?.modulePermissions?.tprm_risk_assessment?.e && row?.modulePermissions?.tprm_risk_assessment?.r) || false,
        edit: row?.modulePermissions?.tprm_risk_assessment?.e || false,
        view: row?.modulePermissions?.tprm_risk_assessment?.r || false
      },
      tprm_questionaire: {
        main: (row?.modulePermissions?.tprm_questionaire?.e && row?.modulePermissions?.tprm_questionaire?.r) || true,
        edit: row?.modulePermissions?.tprm_questionaire?.e || true,
        view: row?.modulePermissions?.tprm_questionaire?.r || true
      }
    });
    setIsEdit(true);
    setContactName(row?.fullName)
    setEmail(row?.email)
    setPhone(row?.contact)
    setCountryCode(row?.countryCode);
    setAccessLevel(row?.accessLevel)
    setTwoFactorEnabled(row?.twoFactorEnabled);
    setServices(row?.services);
    setUserId(row?._id);
    setModal("Form Wizard modal")
  }

  const deleteUserById = (_id) => {
    // const self = this;
    $.confirm({
      title: "Are you sure?",
      content: "Do you really want to delete this customer?",
      type: "red",
      buttons: {
        ok: {
          text: "Delete",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            deleteUser(_id, dispatch,id);
          },
        },
        cancel: function () {
        },
      },
    });
  }

  const sendReminder = () => {
    setReminderModal(false)
    sendUserInvite({
      email: emailId
    })
  }

  const [permissions, setPermissions] = useState({
    attackSurface: {
      main: false,
      edit: false,
      view: false
    },
    dataExposure: {
      main: false,
      edit: false,
      view: false
    },
    brandSecurity: {
      main: false,
      edit: false,
      view: false
    },
    tprm_risk_assessment: {
      main: false,
      edit: false,
      view: false
    },
    tprm_questionaire: {
      main: false,
      edit: false,
      view: false
    }
  });

  const handleMainToggle = (section) => {
    setPermissions(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        main: !prev[section].main,
        edit: !prev[section].main,
        view: !prev[section].main
      }
    }));
  };

  const handleSubToggle = (section, type) => {
    setPermissions(prev => {
      const currentSection = prev[section];

      const newTypeValue = !currentSection[type];

      const newMainState = type === 'edit'
        ? newTypeValue && currentSection.view
        : currentSection.edit && newTypeValue;

      return {
        ...prev,
        [section]: {
          ...currentSection,
          [type]: newTypeValue,
          main: newMainState
        }
      };
    });
  };


  const renderSection = (section, title) => {
    return (
      <div className="form-group col-lg-12 col-md-12 mb-4">
        <div
          className="d-flex justify-content-between pb-3 mb-1 align-items-center"
          style={{ borderBottom: '1px solid #666565' }}
        >
          <div className="checkBox w-100">
            {title}
            <label className="switch mr-2">
              <input
                type="checkbox"
                checked={permissions[section].main}
                onChange={() => handleMainToggle(section)}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
        <ul className="alert-ul">
          <li>
            Edit
            <label className="switch">
              <input
                type="checkbox"
                checked={permissions[section].edit}
                onChange={() => handleMainToggle(section)}
              />
              <span className="slider round"></span>
            </label>
          </li>
          <li>
            View
            <label className="switch">
              <input
                type="checkbox"
                checked={permissions[section].view}
                onChange={() => handleSubToggle(section, 'view')}
              />
              <span className="slider round"></span>
            </label>
          </li>
        </ul>
      </div>
    );
  };


  return (
    <>
      <div className="container-fluid">
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <div className="d-flex align-items-center">
                {/* <Link to="/clients" className="btn btn-sm btn-outline-primary mr-2">
                  <i className="fa fa-arrow-left"></i> Back
                </Link> */}
                <div>
                  <h2 className="welcome-text">Invite User</h2>
                  <nav aria-label="breadcrumb" className="mt-1">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/" className="welcome-textSmall">Home</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/clients">Clients</Link>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page" style={{ color: 'white' }}>
                        Invite User
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
              {authUser?.accessLevel != "Threat Analyst" && (
                  <button
                    type="button"
                    style={{ fontWeight: "bold" }}
                    className="btn btn-sm btn-success NewUserButton"
                    onClick={() => addModal()}
                  >
                    <FontAwesomeIcon icon={faPlus} className="mr-2" />
                    New User
                  </button>
              )}
                {users?.length === 0 ? null : (
                     <a
                     onClick={(e) => {
                      e.preventDefault();
                      exportToCSV(downloadCsvData, "User List");
                    }}
                     href="/add-report"
                     className="btn btn-sm btn-primary mr-1 download-report"
                   >
                     Download Details
                   </a>
                )}
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-12">
            <div className="card">
              <div className="body">
                <div className="row mb-2">
                  <div className="col-lg-3 col-md-6">
                    <div className="searchBoxInput p-0">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="name, email address"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table table-custom spacing5 mb-0">
                    <thead>
                      <tr>
                        <th>Full Name</th>
                        <th>Email Address</th>
                        <th>Contact Number</th>
                        <th>Role</th>
                        <th>Password Reset Status</th>
                        <th>Registration Date</th>
                        {authUser?.accessLevel != "Threat Analyst" && (
                          <th>Actions</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(mapData) && mapData.map((item) => {
                        return (
                          <tr key={item?._id}>
                            <td className="d-flex align-items-center">
                              <img
                                src={item.avatar ? `${IMAGE_URL}${item.avatar}` : imgDummy}
                                alt="Avatar"
                                className="w30 rounded-circle mr-2"
                              />{" "}
                              <p className="mb-0">{item?.fullName || "N/A"}</p>
                            </td>
                            <td>
                              {item?.email || "N/A"}
                            </td>
                            <td>
                              {item?.contact || "N/A"}
                            </td>
                            <td>
                              {item?.accessLevel || "N/A"}
                            </td>
                            <td>
                              {item?.passwordReset ? "Yes" : "No"}
                            </td>
                            <td>
                              {moment(item?.createdAt).format("DD/MM/YYYY hh:mm a") || "N/A"}
                            </td>
                            {authUser?.accessLevel !== "Threat Analyst" && (
                              <td>
                                <Link
                                  to="#"
                                  onClick={() => editModal(item)}
                                  className="mr-2"
                                >
                                  Edit
                                </Link>
                                <Link
                                  to="#"
                                  className="text-danger"
                                  onClick={() => deleteUserById(item?._id)}
                                >
                                  Delete
                                </Link>
                                {authUser?.accessLevel !== "Threat Analyst" && !item.passwordReset && (
                                  <i
                                    style={{
                                      marginLeft: "20px",
                                      fontSize: '20px',
                                      cursor: "pointer"
                                    }}
                                    onClick={() => {
                                      setReminderModal(true);
                                      setEmailId(item.email)
                                    }}
                                    className="fas fa-bell"
                                  ></i>
                                )}
                              </td>
                            )}
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {isEdit ? "Edit User" : "Add New User"}
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setModal("")}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-lg-6 col-md-12">
                        <label className="col-lg-12 col-md-12">Primary Contact Name</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Primary Contact Name *"
                            value={primaryContactName}
                            onChange={(e) => setContactName(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <label className="col-lg-6 col-md-12">Email address</label>
                        <div className="form-group ol-lg-12 col-md-12">
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email address *"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <label className="col-lg-6 col-md-12">Phone</label>
                        <div className="form-group ol-lg-12 col-md-12" style={{ display: "flex" }}>
                          <select className="form-control" value={countryCode} onChange={(e) => setCountryCode(e.target.value)} style={{ width: '100px' }}>
                            {countryCodes?.map((val) => {
                              return <option value={val.dial_code}>{val.name}</option>
                            })}
                          </select>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Phone"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <label className="col-lg-6 col-md-12">Access Level</label>
                        <div className="form-group ol-lg-12 col-md-12">
                          <select className="form-control"
                            value={accessValue}
                            onChange={(e) => setAccessLevel(e.target.value)}
                          >
                            {/* <option value="">-- Email Access * --</option> */}
                            {accessData?.map((row) => {
                              return (
                                <option value={row.val}>{row.text}</option>
                              )
                            })}
                          </select>
                        </div>
                      </div>

                      {accessValue == "client" &&
                        <div className="col-lg-6 col-md-12">
                          <label className="col-lg-6 col-md-12">Module Access</label>
                          {renderSection('attackSurface', 'Attack Surface')}
                          {renderSection('dataExposure', 'Data Exposure')}
                          {renderSection('brandSecurity', 'Brand Security')}
                          {renderSection('tprm_risk_assessment', 'TPRM Risk Assessment')}
                          {renderSection('tprm_questionaire', 'TPRM Questionnaire')}
                        </div>
                      }

                    </div>
                    <div className="row">
                      <div className="col-lg-12 col-md-12" style={{ marginRight: "28px" }}>
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          className="btn btn-round btn-primary mr-1 pull-right"
                          onClick={submitForm}
                        >
                          {isEdit ? "Update" : "Create"}
                        </button>{" "}
                        &nbsp;&nbsp;
                        <button type="button" onClick={() => setModal("")} className="btn btn-round btn-default pull-right" style={{ marginRight: '10px' }}>
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade Form-Wizard-modal ${reminderModal ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Reminder
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  Do you really want to send reminder to this user?
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-round btn-default"
                  data-dismiss="modal"
                  onClick={() => setReminderModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-round btn-primary"
                  style={{ color: "black", fontWeight: "bold" }}
                  onClick={() => {
                    sendReminder()
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default InviteUser;
